import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Date from '../../../../../common/date';
import CustomerMembershipInfoActions from './MembershipInfoActions';
import { t } from '../../../../../../modules/infra/i18n';

const CustomerMembershipInfo = (props) => {
  const statusClassName = cx('c-customer-membership-info-block__status u-type--capitalize', {
    'c-customer-membership-info-block__status--active': props.subscription.status === 'active',
    'c-customer-membership-info-block__status--inactive': props.subscription.status !== 'active',
  });

  return (
    <div>
      <div className="o-flexbox o-flexbox--content-align-center o-flexbox--justify-space-between">
        <div className="c-heading">{t('customers:form.membership.info_heading')}</div>
        <CustomerMembershipInfoActions
          subscription={props.subscription}
          performAction={props.performAction}
          disabled={props.busyIsOn}
        />
      </div>
      <div className="u-text-center u-mt- u-pr">
        <div className="c-customer-membership-info-block u-inline-block">
          <div className="c-customer-membership-info-block__title">{t('customers:form.membership.status_label')}</div>
          <div className={statusClassName}>
            {props.subscription.status}
          </div>
        </div>
        <div className="c-customer-membership-info-block u-inline-block">
          <div className="c-customer-membership-info-block__title">{t('customers:form.membership.type_label')}</div>
          <div className="c-customer-membership-info-block__status">
            {props.subscription.membershipsName}
          </div>
        </div>
        <div className="c-customer-membership-info-block u-inline-block">
          <div className="c-customer-membership-info-block__title">{t('customers:form.membership.started_on_label')}</div>
          <div className="c-customer-membership-info-block__status">
            <Date>{props.subscription.startDate}</Date>
          </div>
        </div>
        <div className="c-customer-membership-info-block u-inline-block">
          <div className="c-customer-membership-info-block__title">{t('customers:form.membership.next_invoice_label')}</div>
          <div className="c-customer-membership-info-block__status">
            <Date>{props.subscription.nextBillingDate}</Date>
          </div>
        </div>
      </div>
    </div>
  );
};

CustomerMembershipInfo.propTypes = {
  busyIsOn: PropTypes.bool.isRequired,
  performAction: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
};

export default CustomerMembershipInfo;
